
export const MUSCLENAME = 'MUSCLENAME'
export const ACTIVEMUSCLEROW = 'ACTIVEMUSCLEROW'
export const ISPLAYING = 'ISPLAYING'
export const SETPROGRESSPLAYPASUE = 'SETPROGRESSPLAYPASUE'
export const INITIALLABLE = 'INITIALLABLE'
export const SLIDERCHANGEVALUE = 'SLIDERCHANGEVALUE'
export const LEFTRIGHTBUTTON = 'RIGHTHANDBUTTON'
export const BASICMODESUBMUSCLES = 'BASICMODESUBMUSCLES'







export const addMuscleName = data => (
    {
        type: MUSCLENAME,
        payload: data
    }

)
export const addActiveMuscleRow = data => (
    {
        type: ACTIVEMUSCLEROW,
        payload: data
    }

)
export const addIsPlaying = data => (
    {
        type: ISPLAYING,
        payload: data
    }

)
export const addSetProgressPlayPause = data => (
    {
        type: SETPROGRESSPLAYPASUE,
        payload: data
    }

)
export const addInitialLable = data => (
    {
        type: INITIALLABLE,
        payload: data
    }

)
export const addSliderChangevalue = data => (
    {
        type: SLIDERCHANGEVALUE,
        payload: data
    }

)
export const addLeftRightButton = data => (
    {
        type: LEFTRIGHTBUTTON,
        payload: data
    }

)
export const addBasicModeSubMuscle = data => (
    {
        type: BASICMODESUBMUSCLES,
        payload: data
    }

)

const initialstate = {
    musclename: '',
    activemusclerow: '',
    isplaying: false,
    setprogressplaypause: {
        ForearmPronation: 0,
        WristFlexion: 0,
        WristRadialDeviation: 0,
        PLMWristFlexion: 0,
        FCUWristFlexion: 0,
        FCUWristUlnarDeviation: 0,
        FDSFingersFlexion: 0,
        PQForearmPronation: 0,
        FDPWristFlexion: 0,
        FDPFingersFlexion: 0,
        FPLThumbFlexion: 0,
        BrachialisElbowFlexion: 0,
        EDFingerExtension: 0,
        ECUWristExtensionExtensorcarpiulnaris: 0,
        ECUWristRadialDeviation: 0,
        ECRLWristExtension: 0,
        ECRBWristExtension: 0,
        EDMLittleFingerExtension: 0,
        EIIndexFingerExtension: 0,
        APLThumbAbduction: 0,
        EPBThumbExtensionMetacarpal: 0,
        EPLThumbExtensionFullThumb: 0,
        OPThumbOpposition: 0,
        APBThumbAbductionAbductorPollicisBrevis: 0,
        APThumbAdduction: 0,
        FPBThumbAdductionThumbFlexionFlexorPollicisBrevis: 0,
        ODMLittleFingerOpposition: 0,
        ADMLittleFingerAbduction: 0,
        LStraightFingerFlexion: 0,
        PBCuppingofHandPalmarisBrevis: 0,
        DICuppingofHand: 0,
        PICuppingofHand: 0,
        Supinator:0,
        LeftRightPalmopen:0,
        HandGrasping :0,
        LeftRightFistClosed:0,
        UpDownPalmopen:0,
        UpDownFistClosed:0,


    },
    initialLable: false,
    sliderchangevalue: 0,
    leftrightbutton: "Righthand",
    basicmodesubmuscle: {}
}

const CommonReducer = (state = initialstate, action) => {
    switch (action.type) {
        case MUSCLENAME:
            return {
                ...state,
                musclename: action.payload

            }
        case ACTIVEMUSCLEROW:
            return {
                ...state,
                activemusclerow: action.payload

            }
        case ISPLAYING:
            return {
                ...state,
                isplaying: action.payload

            }
        case SETPROGRESSPLAYPASUE:
            return {
                ...state,
                setprogressplaypause: { ...state.setprogressplaypause, ...action.payload }


            }
        case INITIALLABLE:
            return {
                ...state,
                initialLable: action.payload


            }
        case SLIDERCHANGEVALUE:
            return {
                ...state,
                sliderchangevalue: action.payload


            }
        case LEFTRIGHTBUTTON:
            return {
                ...state,
                leftrightbutton: action.payload


            }
        case BASICMODESUBMUSCLES:
            return {
                ...state,
                basicmodesubmuscle: action.payload


            }
        default:
            return state;
    }
}
export default CommonReducer;